import axios from "axios";
import apiURL from "./apiURL";
import authHeader from "./authenticationHeader";
import publicIp from "react-public-ip";
import { detect } from "detect-browser";

axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

const API_URL = apiURL();

export let ip;

const browser = detect();

const instance = axios.create({
  baseURL: API_URL,
});

async function getIPAddress() {
  ip = await publicIp.v4();
}
getIPAddress();

const requestInstance = axios.create({});
delete requestInstance.defaults.headers.common["X-Requested-With"];

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    // whatever you want to do with the error
    // clear the session and redirect without showing an error popup.
    if (error.response && error.response.status === 401) {
      localStorage.setItem("isLoggedIn", false);
      window.location.assign(`${process.env.PUBLIC_URL}/authentication/login`);
      return new Promise(() => {});
    }
    throw error;
  }
);

const whatUserDid = (method, parameter, apiData) => {
  let parameterValue = "";
  let apiDataValue = "";

  if (parameter) {
    parameterValue = JSON.stringify(parameter);
  } else {
    parameterValue = "";
  }
  if (apiData) {
    apiDataValue = JSON.stringify(apiData);
  } else {
    apiDataValue = "";
  }

  let whatDid = "";
  switch (method) {
    case "PUT":
      whatDid = `Edit | ${parameterValue}  ${apiDataValue} `;
      break;
    case "DELETE":
      whatDid = `Delete | ${parameterValue}  ${apiDataValue}`;
      break;
    case "PATCH":
      whatDid = `Edit | ${parameterValue}  ${apiDataValue}`;
      break;
    case "POST":
      whatDid = `Insert | ${parameterValue}  ${apiDataValue}`;
      break;
    default:
      whatDid = `Fetch | ${parameterValue}  ${apiDataValue}`;
      break;
  }
  return whatDid;
};

export default {
  servertrip: (apiMethod, apiName, loginUserDetails, apiParam, apiData, apiHeaders) => {
    const extraComment = whatUserDid(apiMethod, apiParam, apiData);

    let pageName = window.location.pathname.split("/")[window.location.pathname.split("/").length - 1];

    let body = {
      dev_id: loginUserDetails?.dev_id,
      email_id: loginUserDetails?.user_name,
      dev_name: loginUserDetails?.dev_name,
      is_admin: loginUserDetails?.is_partner === "0" ? "yes" : "no",
      app_id: "",
      page_name: pageName
        .split("-")
        .map((data) => data.charAt(0).toUpperCase() + data.slice(1))
        .join(" "),
      action_name: apiName
        .split("_")
        .map((data) => data.charAt(0).toUpperCase() + data.slice(1))
        .join(" "),
      project_name: "API Portal v4.0",
      ip_address: ip,
      browser_name: browser.name.charAt(0).toUpperCase() + browser.name.slice(1),
      browser_version: browser.version,
      extra_comment: extraComment,
      host_name: window.location.hostname,
    };

    if (apiMethod !== "GET" && body.host_name !== "localhost") {
      axios
        .post(`${API_URL}/visit`, body, { withCredentials: true })
        .then(() => {})
        .catch(() => {
          // localStorage.removeItem("actn");
          // localStorage.removeItem("lngst");
          // localStorage.removeItem("tempData");
          // window.location.assign(`${process.env.PUBLIC_URL}/authentication/login`);
        });
    }

    return instance({
      method: apiMethod,
      url: apiName,
      params: apiParam,
      data: apiData,
      headers: apiHeaders,
      withCredentials: true,
    });
  },

  customRequest: (apiMethod, apiName, apiParam, apiData, apiHeaders, responseType) => {
    const loginUserDetails = JSON.parse(localStorage.getItem("tempData"));

    axios.defaults.withCredentials = true;

    const extraComment = whatUserDid(apiMethod, apiParam, apiData);

    let pageName = window.location.pathname.split("/")[window.location.pathname.split("/").length - 1];

    const body = {
      dev_id: loginUserDetails?.dev_id,
      email_id: loginUserDetails?.user_name,
      dev_name: loginUserDetails?.dev_name,
      is_admin: loginUserDetails?.is_partner === "0" ? "yes" : "no",
      app_id: "",
      page_name: pageName
        .split("-")
        .map((data) => data.charAt(0).toUpperCase() + data.slice(1))
        .join(" "),
      action_name: apiName
        .split("_")
        .map((data) => data.charAt(0).toUpperCase() + data.slice(1))
        .join(" "),
      project_name: "API Portal v4.0",
      ip_address: ip,
      browser_name: browser.name.charAt(0).toUpperCase() + browser.name.slice(1),
      browser_version: browser.version,
      extra_comment: extraComment,
      host_name: window.location.hostname,
    };
    if (apiMethod !== "GET" && body.host_name !== "localhost") {
      axios
        .post(`${API_URL}/visit`, body, { headers: authHeader() })
        .then(() => {})
        .catch(() => {
          // localStorage.removeItem("actn");
          // localStorage.removeItem("lngst");
          // localStorage.removeItem("tempData");
          // window.location.assign(`${process.env.PUBLIC_URL}/authentication/login`);
        });
    }

    return instance({
      method: apiMethod,
      url: apiName,
      params: apiParam,
      data: apiData,
      headers: {
        ...apiHeaders,
      },
      responseType: responseType,
      withCredentials: true,
    });
  },

  makeRequest: (
    method = "GET",
    url = "https://jsonplaceholder.typicode.com/users",
    params = {},
    headers = {},
    data = {}
  ) => {
    return requestInstance({
      method: method,
      url: url,
      params: params,
      headers: headers,
      data: data, // Adding this causes CORS
    });
  },
};